<template>
  <div class="basket-empty-body">
    <div v-if="isProcessingDiscounts" class="discount-processing-wrap">
      <div class="discount-processing-text">{{phrases.BASKET_CALCULATE_DISCOUNTS}}</div>
    </div>
    <div class="basket-empty-logo">
      <span class="pp-icon pp-icon-cat"></span>
      <div class="basket-empty-title">{{phrases.BASKET_EMPTY}}</div>
      <div class="basket-empty-description">{{phrases.BASKET_TEXT_FOR_ORDER}}</div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "BasketEmpty",
  computed: {
    ...mapGetters('app', {
      phrases: 'getPhrases',
      isProcessingDiscounts: 'getProcessDiscount'
    }),
  }
}
</script>

<style scoped lang="scss">
  .basket-body {
    .discount-processing {
      &-wrap{
        display: flex;
        position: absolute;
        opacity: 0.85;
        background-color: #fff;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        align-items: center;
        justify-content: center;
      }
      &-text{
        font-size: 2rem;
        font-family: 'Panton Extrabold',sans-serif;
      }
    }
  }
</style>